import { render } from "./IoUThresholdFilter.vue?vue&type=template&id=5c6f6f2a&scoped=true"
import script from "./IoUThresholdFilter.vue?vue&type=script&lang=js"
export * from "./IoUThresholdFilter.vue?vue&type=script&lang=js"

import "./IoUThresholdFilter.vue?vue&type=style&index=0&id=5c6f6f2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6f6f2a"]])

export default __exports__